import { useEffect, useState } from "react";
import { newAuthService } from "Service/Axios";
import { getUserProfileCompletionUrl } from "Constant/api";

export const CompletionStatus = () => {
  const [completionPercent, setCompletionPercent] = useState(0);
  const [loading, setLoading] = useState(true);

  const getCompletionColor = (percent) => {
    if (percent <= 0) return "#E53935"; // Red
    if (percent <= 40) return "#FB8C00"; // Orange
    if (percent <= 70) return "#FDD835"; // Yellow-Green
    if (percent <= 85) return "#C0CA33"; // Soft Green
    if (percent <= 95) return "#43A047"; // Rich Green
    return "#2E7D32"; // Final Green (100%)
  };

  const fetchCompletionStatus = async () => {
    const response = await newAuthService(
      getUserProfileCompletionUrl,
      "POST",
      {}
    );
    setLoading(false);
    if (response?.status) {
      setCompletionPercent(response.data || 0);
    } else {
      setCompletionPercent(0);
    }
  };

  useEffect(() => {
    fetchCompletionStatus();
  }, []);

  if (loading) {
    return <div>Loading Completion Status...</div>;
  }

  if (completionPercent === 100) {
    return null;
  }

  return (
    <div className="p-4 rounded-lg border border-orange-200 bg-orange-50">
      <div className="card-body">
        <p className="mb-3">Finish setting up your profile.</p>

        <div className="position-relative mb-2">
          <div className="progress h-2">
            <div
              className="progress-bar"
              role="progressbar"
              style={{
                width: `${completionPercent}%`,
                background: getCompletionColor(completionPercent),
              }}
              aria-valuenow={completionPercent}
              aria-valuemin="0"
              aria-valuemax="100"
            ></div>
          </div>
          <div
            className="position-absolute top-50 translate-middle-y"
            style={{ left: `${completionPercent}%` }}
          >
            <i className="bi bi-exclamation-triangle-fill text-warning"></i>
          </div>
        </div>

        <div className="mb-3">
          <strong>Profile Completion:</strong> {completionPercent}%
        </div>
      </div>
    </div>
  );
};
